export class Article {
	
	sendComment(parent, replyto = null)
	{
		var el = $(parent);
		
		if (!el.find('textarea[name="txt_comment"]').val()) return false;
		el.find('*[type=submit]').attr('disabled', true);
		
		$.ajax({
			url: "/ajax.php?mid=48",
			type: 'POST',
			data: {
				text : el.find('textarea[name="txt_comment"]').val(),
				item_id: el.find('#comm_item').val(),
				last : el.find('#comm_last').val(),
				replyto : replyto,
				congr : 0
				},
			dataType: "json",
			success: function(res){
				var form = $(parent);
				form.find('*[type=submit]').attr('disabled', false);
				
				if (res['success'])
				{
					var last = res['last']
					
					form.find('textarea[name="txt_comment"]').val('');
					//ga('send', 'event', 'Interactive', 'add_comment', "'" + last + "'");
					
					form.find('#comm_last').val(last);
					//$('#comments .no_comm').remove();
					
					form.closest('.comments').find('.comments-content__list:first').append(res['li']);
				}
				else if (res['need_auth'])
				{	
					form.find('.new-comment__mistake').text(res['error']);
					ajax_auth();
				}
				else if (res['need_name'])
				{	
					form.find('.new-comment__mistake').text(res['error']);
				}
				else
				{	
					form.find('.new-comment__mistake').text(res['error']);
				}
			},
			error: function(res){
				$('#comments input').attr('disabled', false);
				alert('Ошибка отправки данных. Пожалуйста, попробуйте ещё раз или обратитесь к администратору сайта');
			}			
		});
	}
	
	sendCongrats(parent)
	{
		var el = $(parent);
		
		if (!el.find('textarea[name="txt_comment"]').val()) return false;
		el.find('*[type=submit]').attr('disabled', true);
		
		$.ajax({
			url: "/ajax.php?mid=48",
			type: 'POST',
			data: {
				text : el.find('textarea[name="txt_comment"]').val(),
				item_id: el.find('#comm_item').val(),
				last : el.find('#comm_last').val(),
				congr : 1
				},
			dataType: "json",
			success: function(res){
				var form = $(parent);
				form.find('*[type=submit]').attr('disabled', false);
				
				if (res['success'])
				{
					var last = res['last']
					
					form.find('textarea[name="txt_comment"]').val('');
					//ga('send', 'event', 'Interactive', 'add_comment', "'" + last + "'");
					
					form.find('#comm_last').val(last);
					//$('#comments .no_comm').remove();
					
					form.closest('.comments').find('.comments-content__list:first').append(res['li']);
				}
				else if (res['need_auth'])
				{	
					form.find('.new-comment__mistake').text(res['error']);
					ajax_auth();
				}
				else if (res['need_name'])
				{	
					form.find('.new-comment__mistake').text(res['error']);
				}
				else
				{	
					form.find('.new-comment__mistake').text(res['error']);
				}
			},
			error: function(res){
				$('#comments input').attr('disabled', false);
				alert('Ошибка отправки данных. Пожалуйста, попробуйте ещё раз или обратитесь к администратору сайта');
			}			
		});
	}
	

	showDeleteCommentPopup(id, parent)
	{
		let comm = $(parent).closest('.comment__main');
		let popup = $(".popup[data-popup-name=popup-delete-comment]");
		popup.find('.popup-delete-comment__form-teaser em').text('"' + comm.find('.comment__content .text-block').text() + '"');
		popup.find('.delete-comment__button').attr('data-id', id);

		popup.find('.form__main').show();
		popup.find('.form__success').hide();
		popup.find('.delete-comment__mistake').text('').hide();

		$("body").addClass("no-scroll");
		popup.addClass("active");
	}

	deleteComment(parent)
	{
		let el = $(parent);
		let form =el.closest('form');
		let id = el.attr('data-id');
		
		$.ajax({
			url: "/ajax.php?mid=48",
			type: 'POST',
			data: {
				action: 'deleteComment',
				item_id: id,
				},
			dataType: "json",
			success: function(res){
				if (res['success'])
				{
					$('.comments-content__item[data-id=' + id + ']').remove();
					form.find('.form__main').hide();
					form.find('.form__success').show();
				}
				else if (res['need_auth'])
				{	
					form.find('.delete-comment__mistake').text(res['error']).show();
					ajax_auth();
				}
				else
				{	
					form.find('.delete-comment__mistake').text(res['error']).show();
				}
			},
			error: function(res){
				alert('Ошибка отправки данных. Пожалуйста, попробуйте ещё раз или обратитесь к администратору сайта');
			}			
		});
	}

	toggleSubscribe(id, parent)
	{
		if ($(parent).hasClass('active'))
		{
			this.commentUnsubscribe(id, parent);
		}
		else
		{
			this.commentSubscribe(id, parent);
		}
	}

	commentSubscribe(id, parent){
		let btn = $(parent);
		btn.prop('disabled', true);

		$.ajax({
			url: "/ajax.php?mid=48",
			type: 'POST',
			data: {
				action: 'subscribe',
				item_id: id,
				},
			dataType: "json",
			success: function(res){
				btn.prop('disabled', false);
				
				if (res['success'])
				{
					btn.addClass('active')
					btn.find('span').text('Отписаться от\xa0комментариев');
				}
				else
				{
					alert('Ошибка: ' + res['error']);
				}
			},
			error: function(res){
				alert('Ошибка отправки данных. Пожалуйста, попробуйте ещё раз или обратитесь к администратору сайта');
			}			
		});	
		
	}

	commentUnsubscribe(id, parent){
		var btn = $(parent);
		btn.prop('disabled', true);

		$.ajax({
			url: "/ajax.php?mid=48",
			type: 'POST',
			data: {
				action: 'unsubscribe',
				item_id: id,
				},
			dataType: "json",
			success: function(res){
				btn.prop('disabled', false);
				
				if (res['success'])
				{
					btn.removeClass('active')
					btn.find('span').text('Подписаться на\xa0комментарии');
				}
				else
				{
					alert('Ошибка: ' + res['error']);
				}
			},
			error: function(res){
				alert('Ошибка отправки данных. Пожалуйста, попробуйте ещё раз или обратитесь к администратору сайта');
			}			
		});	
		
	}
		
		
	sendAbuse(){	

	   $.ajax({
            url: "/ajax.php?mid=43",
            type: 'POST',
            data: {
                action: 'abuse',
                article_id: $('button.send_abuse').data('id'),
                comment_id: $('button.send_abuse').data('comment')
                },
            dataType: "json",
            success: function(res){
                if(res.result == 'fail'){
					ajax_auth();
				}else{
					alert('Ваша жалоба отправлена');
				}
            },
            error: function(err){
                console.log(err);
            }
        });

	}

}